const ELEMENT_IDS = {
  CONFIRM_MODAL_OK_BUTTON: 'CONFIRM_MODAL_OK_BUTTON',
  BREADCRUMB_CONTAINER: 'BREADCRUMB_CONTAINER',
  NAV_TITLE_CONTAINER: 'NAV_TITLE_CONTAINER'
};

export default ELEMENT_IDS;
